module.exports = __webpack_public_path__ + "img/HQ-PA1W1T2RUH-V2_ALL.8bc24199.jpg";